module.exports = __webpack_public_path__ + "img/shopifyLoginImg.4a2e999a.svg";